export const authHeaders = (): { Authorization: string } => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const getRole = (): string | null => localStorage.getItem('role');

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
};

/**
 * True if there's no saved token, or the saved token has expired.
 * Reads the `exp` claim from the JWT payload (no verification needed: the
 * server still checks the signature on every request). A token we can't
 * parse counts as expired.
 */
export const isSessionExpired = (): boolean => {
  const token = localStorage.getItem('token');
  if (!token) return true;
  try {
    const payload = token.split('.')[1];
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const { exp } = JSON.parse(json) as { exp?: number };
    if (typeof exp !== 'number') return false; // no expiry claim: let the server decide
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

/**
 * Clears the session and sends the user to the login page with a
 * "session expired" message. Uses a full page load so no stale page state
 * (half-loaded lists, open modals) survives.
 */
export const endExpiredSession = () => {
  logout();
  if (window.location.pathname !== '/login') {
    window.location.assign('/login?expired=1');
  }
};
